import { createFileRoute } from '@tanstack/react-router'

import DetailPnsPppkPage from '@/components/pages/backoffice/_ktg-penyuluh/pns-pppk/$pnsPppkId/containers/DetailPnsPppkPage'

export const Route = createFileRoute(
  '/_backoffice/ktg-penyuluh/pns-pppk/$pnsPppkId/'
)({
  component: DetailPnsPppkPage
})
